module.exports = __webpack_public_path__ + "img/11.b7c6368e.png";